module.exports = __webpack_public_path__ + "img/notification.c3fabce5.svg";